import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ColumnProvider } from '../interfaces/ColumnProvider';
import { createSurfaceItem } from './createSurfaceItem';
import { merge } from './merge';
import { SurfaceItem } from '../interfaces/SurfaceItem';

/**
 * Creates a surface item to represent the given model.
 * @param key A key that identifies this surface item, to be given to React elements created from this item.
 * @param model The model that will be represented by the SurfaceItem.
 * @param columnProvider The column provider that can place the model in the desired column.
 * @returns A surface item, which can be manipulated as a LayoutInterval.
 */
export function createSurfaceItemFromModel(
    key: string,
    model: CalendarEvent,
    columnProvider: ColumnProvider,
    minimumItemSizeInMinutes: number = 30
): SurfaceItem {
    let intervals = columnProvider.getColumnIntervals(model);
    return intervals.length > 0 ? createSurfaceItem(merge(intervals), key, model) : null;
}
